<div *ngIf="navServices.getUserName() && message != ''">
    <div class="alert alert-info font-weight-bold mb-0 rounded-0 text-center text-danger">
        <i class="fas fa-exclamation-triangle"></i> {{message}}
    </div>
</div>